var map = {
	"./img1.jpg": 2393,
	"./img10.jpg": 2394,
	"./img2.jpg": 2395,
	"./img3.jpg": 2396,
	"./img4.jpg": 2397,
	"./img5.jpg": 2398,
	"./img6.jpg": 2399,
	"./img7.jpg": 2400,
	"./img8.jpg": 2401,
	"./img9.jpg": 2402
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2392;